<template>
  <div class="component">
    <b-breadcrumb :items="items"></b-breadcrumb>
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <div class="row">
                 <div class="col-6">
                  <h5 class="card-title mt-1">{{!id ? 'Nova' : 'Editar'}} Unidade</h5>
                </div>
                <div class="col-6">
                  <button
                    type="button"
                    v-on:click="save()"
                    class="btn btn-success float-right"
                  ><span>Salvar <font-awesome-icon icon="save" /> </span></button>
                </div>
              </div>
              <hr />
              <div class="form-group">
                <label for="name">
                  Nome
                  <span v-if="required('name')">*</span>
                </label>

                <input
                  name="name"
                  v-model="unit.name"
                  type="text"
                  class="form-control"
                  v-bind:class="{'input-error': showError('name')}"
                />
                <div class="general-error" v-if="showError('name')">O campo Nome é necessário</div>
              </div>
              <div class="form-group">
                <label for="name">
                  Companhia
                  <span v-if="required('company')">*</span>
                </label>

                <select
                  class="form-control"
                  v-model="unit.company"
                  id="exampleFormControlSelect1"
                  v-bind:class="{'input-error': showError('company')}"
                >
                  <option
                    v-for="company in companies"
                    :value="company.id"
                    v-bind:key="company.id"
                  >{{company.corporate_name}}</option>
                </select>
                <div
                  class="general-error"
                  v-if="showError('company')"
                >O campo Companhia é necessário</div>
              </div>

              <Address :data="address" :submited="submited"></Address>

              <div class="form-group">
                <label>
                  Setor
                  <span v-if="$v.lista_setor.$params.required">*</span>
                </label>
                <div class="input-group-prepend">
                  <input
                    name="sector"
                    v-model="unit.sector"
                    class="form-control col-5"
                    type="text"
                    v-bind:class="{'input-error': $v.lista_setor.$invalid && submited}"
                  />
                  <button
                    class="btn btn-success"
                    style="margin-left: 8px"
                    type="button"
                    v-on:click="saveList()"
                  >Adicionar</button>
                </div>
                <div
                  class="general-error"
                  v-if="$v.lista_setor.$invalid && submited"
                >Adicione ao menos um Setor</div>
                <div class="content-sector mt-5">
                  <div class="row" v-for="(item, index) in lista_setor" :key="item">
                    <div class="col-10">
                      <p>{{ item }}</p>
                      <hr />
                    </div>
                    <div class="col-2">
                      <div class="icon" v-on:click="deleteFromList(index)">
                        <font-awesome-icon icon="times" />
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <b-alert
                    v-show="success"
                    variant="success"
                    show
                  >Unidade {{!unit.id ? 'Criada' : 'Salva'}}</b-alert>
                  <b-alert v-show="warning" variant="warning" show>Ocorreu um erro</b-alert>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Address from "@/components/AddressFields.vue";

import axios from "@/api/axios";
import { required, minLength } from "vuelidate/lib/validators";

export default {
  name: "Unit_New",
  props: {
    id: String
  },
  components: {
    Address
  },
  data() {
    return {
      lista_setor: [],
      companies: [],
      unit: {},
      value_password: "password",
      submited: false,
      address: {},
      group: {},
      user: {},
      success: false,
      warning: false,
      items: [
        {
          text: "Unidades",
          href: "#/admin/Units/ListUnits"
        },
        {
          text: "Nova",
          active: true
        }
      ]
    };
  },

  mounted() {
    this.getUnit();
    // if (this.id) {
    //   this.getUser();
    // }
  },
  validations: {
    unit: {
      name: {
        required
      },
      company: {
        required
      }
    },
    lista_setor: {
      required,
      minLength: minLength(1)
    }
  },
  methods: {
    saveList: function() {
      if (this.lista_setor.includes(this.unit.sector) == false) {
        this.lista_setor.push(this.unit.sector);
      }
    },

    deleteFromList: function(index) {
      this.lista_setor.splice(index, 1);
    },

    show_password: function() {
      this.value_password =
        this.value_password == "password" ? "text" : "password";
    },
    save: function() {
      this.submited = true;
      if (!this.$v.$invalid) {
        if (!this.unit.id) {
          axios
            .post(`${process.env.VUE_APP_API_HOST}/api/admin/units`, {
              name: this.unit.name,
              company_id: this.unit.company,
              address: this.address,
              sectors: this.lista_setor
            })
            .then(response => {
              this.success = true;
              setTimeout(() => {
                this.success = false;
              }, 3000);
              return response.data;
            })
            .catch(() => {
              this.warning = true;
            });
        } else {
          this.edit();
        }
      }
    },
    showError: function(attribute) {
      return this.$v.unit[attribute].$invalid && this.submited;
    },
    required: function(attribute) {
      return this.$v.unit[attribute].$params.required;
    },

    edit: function() {
      axios
        .put(
          `${process.env.VUE_APP_API_HOST}/api/admin/units/` + this.user.id,
          {
            name: this.unit.name
          }
        )
        .then(response => {
          this.success = true;
          setTimeout(() => {
            this.success = false;
            //redirect
          }, 3000);
          return response.data;
        })
        .catch(() => {
          this.warning = true;
        });
    },

    getUnit: function() {
      axios
        .get(`${process.env.VUE_APP_API_HOST}/api/admin/units/` + this.id)
        .then(response => {
          this.unit = response.data.data;
        });
    }
  }
};
</script>

<style lang="scss">
@import "../../../styles/CorporateGroupCreate.scss";
</style>
